import {getAppLang, getProperty, getUserToken} from "../../../../utils";
import axios from "axios";
import {GET_ROOM_SIZE_TYPES} from "../../../../constants/api.constants";

export function getRoomSizeTypes() {

    const requestOptions = {
        headers: { 'Content-Type': 'application/json',  'authToken': getUserToken(), 'language' : getAppLang()},
        body: {
            params: {
                "property_id" : getProperty(),
            }
        }
    };

    return dispatch => {
        dispatch({
            type: 'GET_ROOM_SIZE_TYPES',
            payload: axios.post(GET_ROOM_SIZE_TYPES, requestOptions.body, {headers: requestOptions.headers})
                .then(response => response.data.data)
        })
    }
}